import { animated, useSpring } from '@react-spring/web';
import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { urgentDate, warningDark } from '../../../styles/colors';
import { DangerIcon } from '../../svgs/icons/DangerIcon';
import { styleSheet } from './styles';

interface IProps {
	animate?: boolean;
	children: React.ReactNode;
	iconBackgroundColor?: string;
	iconBorderColor?: string;
	iconColor?: string;
	styles?: StyleDeclarationValue[];
	type?: 'warning' | 'error';
}

export const DangerMessage = ({
	animate = true,
	children,
	iconBackgroundColor,
	iconBorderColor,
	iconColor,
	styles,
	type = 'warning',
}: IProps) => {
	const spring = useSpring({
		from: { opacity: 0 },
		to: { opacity: 1 },
		immediate: !animate,
	});

	const AnimatedDiv = animated.div;

	return (
		<AnimatedDiv
			className={`${css(
				styleSheet.container,
				type === 'error' ? styleSheet.errorMessage : styleSheet.warningMessage,
				...(styles || [])
			)} notification-message`}
			style={spring}
		>
			<div className={css(styleSheet.icon)}>
				<DangerIcon
					borderColor={iconBorderColor ?? '#fff'}
					backgroundColor={iconBackgroundColor ?? (type === 'error' ? urgentDate : warningDark)}
					foregroundColor={iconColor}
				/>
			</div>
			<div className={css(styleSheet.content)}>{children}</div>
		</AnimatedDiv>
	);
};
